function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { DebounceInput } from "react-debounce-input";
import { GoSearch } from "react-icons/go";
import { MdDateRange } from "react-icons/md";
import "./TaskDetails.css";
import { HiInformationCircle, HiArrowCircleLeft } from "react-icons/hi";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Field, Form, Formik } from "formik";
import Forms from "react-bootstrap/Form";
import { TASK_DETAILS_QUERY, ASSIGN_EMPLOYEE_TO_TASK_MUTATION, DELETE_TASK_EMPLOYEE_MUTATION } from "./query";
import { useQuery, useMutation } from "@apollo/client";
import { FilterContext, UserContext } from "../index";
import moment from "moment-timezone";
import { TaskModal, DeleteTaskModal } from "./TaskModal";
import { toast } from "react-toastify";
import { findDemoOrLiveSite } from "../SideMenu/Header";
import { arrayToStringOutput } from "./../SideMenu/Header";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Helmet } from "react-helmet";
import Loader from "./../Loader/Loader";
import format from "date-fns/format";
import isSameDay from "date-fns/isSameDay";
import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
var TASK_LIMIT = 10;
var TASK_OFFSETS = 0;
var TaskDetails = function TaskDetails(props) {
  var _props$match, _taskDetailsData$task5, _taskDetailsData$task6, _taskDetailsData$task7;
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    teamId = _React$useContext2.teamId,
    organisationId = _React$useContext2.organisationId,
    sD = _React$useContext2.startDate,
    eD = _React$useContext2.endDate,
    organisationSettings = _React$useContext2.organisationSettings,
    role = _React$useContext2.role;
  var _props$match$params = props === null || props === void 0 ? void 0 : (_props$match = props.match) === null || _props$match === void 0 ? void 0 : _props$match.params,
    projectId = _props$match$params.projectId,
    taskId = _props$match$params.taskId;
  var userId = user === null || user === void 0 ? void 0 : user.userId; //taskId

  var history = props.history;
  var dateFilter = arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  var startDate = Number(moment(sD).format("x"));
  var endDate = Number(moment(eD ? eD : sD).format("x"));
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isAllLoaded = _React$useState2[0],
    setIsAllLoaded = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLoadingMore = _React$useState4[0],
    setIsLoadingMore = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isLoadMoreButton = _React$useState6[0],
    setIsLoadMoreButton = _React$useState6[1];
  var _useQuery = useQuery(TASK_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        taskId: taskId,
        projectId: projectId,
        startDate: startDate,
        endDate: endDate,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: TASK_LIMIT,
        offset: 0,
        role: role,
        userUrl: user === null || user === void 0 ? void 0 : user.uniqueUrl
      },
      skip: !organisationId
    }),
    taskDetailsData = _useQuery.data,
    taskDetailsError = _useQuery.error,
    taskDetailsLoading = _useQuery.loading,
    taskDetailsRefetch = _useQuery.refetch,
    taskDetailsFetchMore = _useQuery.fetchMore;
  React.useEffect(function () {
    taskDetailsRefetch === null || taskDetailsRefetch === void 0 ? void 0 : taskDetailsRefetch();
  }, [props.location.key]);
  React.useEffect(function () {
    var _taskDetailsData$task, _taskDetailsData$task2, _taskDetailsData$task3, _taskDetailsData$task4;
    setIsAllLoaded((taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task = taskDetailsData.taskDetails) === null || _taskDetailsData$task === void 0 ? void 0 : (_taskDetailsData$task2 = _taskDetailsData$task.employeeDetails) === null || _taskDetailsData$task2 === void 0 ? void 0 : _taskDetailsData$task2.length) != 0 && (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task3 = taskDetailsData.taskDetails) === null || _taskDetailsData$task3 === void 0 ? void 0 : (_taskDetailsData$task4 = _taskDetailsData$task3.employeeDetails) === null || _taskDetailsData$task4 === void 0 ? void 0 : _taskDetailsData$task4.length) < TASK_LIMIT ? true : false);
  }, [taskDetailsData]);
  if (taskDetailsLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (taskDetailsError) {
    return /*#__PURE__*/React.createElement("div", null, "Error");
  }
  if (!taskDetailsData) {
    return null;
  }
  var existUserIds = taskDetailsData.taskDetails.employeeDetails.map(function (user) {
    return user.userId;
  });
  var isDemoOrLiveSite = findDemoOrLiveSite();
  var startDateFormat = moment(startDate).format("YYYY-MM-DD");
  var endDateFormat = moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD");
  return /*#__PURE__*/React.createElement("div", {
    className: "task-details-root"
  }, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Workfolio | Task Details | ".concat(taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task5 = taskDetailsData.taskDetails) === null || _taskDetailsData$task5 === void 0 ? void 0 : (_taskDetailsData$task6 = _taskDetailsData$task5.taskData) === null || _taskDetailsData$task6 === void 0 ? void 0 : _taskDetailsData$task6.taskName))), /*#__PURE__*/React.createElement(TaskDetailsData, {
    taskData: taskDetailsData,
    taskSummary: taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task7 = taskDetailsData.taskDetails) === null || _taskDetailsData$task7 === void 0 ? void 0 : _taskDetailsData$task7.taskSummary
    // teamUser={taskDetailsData.taskDetails.teamUser}
    ,
    projectId: projectId,
    taskId: taskId,
    organisationId: organisationId,
    existUserIds: existUserIds,
    userId: userId,
    isDemoOrLiveSite: isDemoOrLiveSite,
    history: props.history,
    dateFilter: dateFilter,
    teamId: teamId,
    startDate: startDate,
    endDate: endDate,
    TASK_LIMIT: TASK_LIMIT,
    timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
  }), /*#__PURE__*/React.createElement(EmployeeListCard, {
    employeeDetails: taskDetailsData.taskDetails.employeeDetails
    // teamUser={taskDetailsData.taskDetails.teamUser}
    ,
    organisationId: organisationId,
    taskId: taskId,
    projectId: projectId,
    teamId: teamId,
    userId: userId,
    existUserIds: existUserIds,
    isDemoOrLiveSite: isDemoOrLiveSite,
    taskDetailsFetchMore: taskDetailsFetchMore,
    taskDetailsLoading: taskDetailsLoading,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    setIsLoadingMore: setIsLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    setIsLoadMoreButton: setIsLoadMoreButton
  }));
};
var TaskDetailsData = function TaskDetailsData(props) {
  var _taskData$taskDetails, _taskData$taskDetails2;
  var taskData = props.taskData,
    taskSummary = props.taskSummary,
    projectId = props.projectId,
    taskId = props.taskId,
    organisationId = props.organisationId,
    existUserIds = props.existUserIds,
    userId = props.userId,
    isDemoOrLiveSite = props.isDemoOrLiveSite,
    dateFilter = props.dateFilter,
    teamId = props.teamId,
    startDate = props.startDate,
    endDate = props.endDate,
    TASK_LIMIT = props.TASK_LIMIT,
    timezone = props.timezone;
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    taskDetails = _React$useState8[0],
    setShowNewTaskModal = _React$useState8[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTaskDeleteModal = _useState2[0],
    setShowDeleteTaskModal = _useState2[1];
  var handleClose = function handleClose() {
    return setShowNewTaskModal(false);
  };
  var handleShow = function handleShow() {
    return setShowNewTaskModal(true);
  };
  var handleTaskDeleteClose = function handleTaskDeleteClose() {
    return setShowDeleteTaskModal(false);
  };
  var handleTaskDeleteShow = function handleTaskDeleteShow() {
    return setShowDeleteTaskModal(true);
  };
  var taskDetailValue = taskData === null || taskData === void 0 ? void 0 : (_taskData$taskDetails = taskData.taskDetails) === null || _taskData$taskDetails === void 0 ? void 0 : _taskData$taskDetails.taskData;
  var taskUser = taskData === null || taskData === void 0 ? void 0 : (_taskData$taskDetails2 = taskData.taskDetails) === null || _taskData$taskDetails2 === void 0 ? void 0 : _taskData$taskDetails2.taskUser;
  return /*#__PURE__*/React.createElement("div", {
    className: "task-details-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary-name-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-data-task-back-button",
    onClick: props.history.goBack
  }, /*#__PURE__*/React.createElement(HiArrowCircleLeft, null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary-project-name-value"
  }, taskDetailValue === null || taskDetailValue === void 0 ? void 0 : taskDetailValue.projectName), /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary-name-value"
  }, (taskDetailValue === null || taskDetailValue === void 0 ? void 0 : taskDetailValue.taskName.charAt(0).toUpperCase()) + (taskDetailValue === null || taskDetailValue === void 0 ? void 0 : taskDetailValue.taskName.slice(1))), /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary-name-edit-value-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary-name-edit-value",
    onClick: function onClick() {
      return handleShow(true);
    }
  }, "Edit task settings"), /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary-name-edit-value",
    onClick: function onClick() {
      return handleTaskDeleteShow(true);
    }
  }, "Delete task")))), /*#__PURE__*/React.createElement("div", {
    className: "task-details-card"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-demo-site"
    }, dateFilter, " Worked Hours")
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-card-title text-dark"
  }, dateFilter, " Worked Hours")), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark"
  }, taskSummary.totalTimeOnFilterTask)), /*#__PURE__*/React.createElement("div", {
    className: "task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-card-title text-dark"
  }, "Total Worked Hours"), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark"
  }, taskSummary.totalTimeOnTask)), /*#__PURE__*/React.createElement("div", {
    className: "task-details-card"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "task-details-card-title text-dark"
  }, "Task Created By"), /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-demo-site"
    }, moment(taskSummary.taskCreatedAt).format("DD MMM, YYYY hh:mm A"))
  }, /*#__PURE__*/React.createElement("span", {
    className: "task-details-card-task-created-at"
  }, /*#__PURE__*/React.createElement(HiInformationCircle, null)))), /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-demo-site"
    }, taskSummary.createdBy)
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark task-details-card-title-text"
  }, taskSummary.createdBy)))), /*#__PURE__*/React.createElement(TaskModal, {
    taskData: taskDetailValue,
    taskSummary: taskSummary,
    taskDetails: taskDetails,
    handleClose: handleClose,
    projectId: projectId,
    taskId: taskId,
    organisationId: organisationId
    // teamUser={teamUser}
    ,
    existUserIds: existUserIds,
    userId: userId,
    startDate: startDate,
    endDate: endDate,
    timezone: timezone,
    taskUser: taskUser,
    user: user,
    role: role
  }), /*#__PURE__*/React.createElement(DeleteTaskModal, {
    showTaskDeleteModal: showTaskDeleteModal,
    handleTaskDeleteClose: handleTaskDeleteClose,
    taskId: taskId,
    organisationId: organisationId,
    projectId: projectId,
    userId: userId,
    history: props.history,
    teamId: teamId,
    startDate: startDate,
    endDate: endDate,
    TASK_LIMIT: TASK_LIMIT,
    timezone: timezone,
    user: user,
    role: role
  }));
};
var TaskDetailsCard = function TaskDetailsCard(props) {
  var taskSummary = props.taskSummary,
    taskData = props.taskData;
  return /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary-name-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary-name-header-avatar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary-name-icon"
  }, taskData.taskName.charAt(0).toUpperCase())), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary-name-value"
  }, taskData.taskName.charAt(0).toUpperCase() + taskData.taskName.slice(1)), /*#__PURE__*/React.createElement("div", {
    className: "task-details-summary-name-edit-value"
  }, "Edit task settings"))), /*#__PURE__*/React.createElement("div", {
    className: "task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-card-title text-dark"
  }, "Total Worked Hours"), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark"
  }, "45h 30m")), /*#__PURE__*/React.createElement("div", {
    className: "task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-card-title text-dark"
  }, "Today Worked Hours"), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark"
  }, "5h 30m")), /*#__PURE__*/React.createElement("div", {
    className: "task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-card-title text-dark"
  }, "Task Created By"), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark"
  }, "John doe")));
};
var EmployeeListCard = function EmployeeListCard(props) {
  var employeeDetails = props.employeeDetails,
    organisationId = props.organisationId,
    taskId = props.taskId,
    projectId = props.projectId,
    teamId = props.teamId,
    userId = props.userId,
    existUserIds = props.existUserIds,
    isDemoOrLiveSite = props.isDemoOrLiveSite,
    taskDetailsFetchMore = props.taskDetailsFetchMore,
    taskDetailsLoading = props.taskDetailsLoading,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    setIsLoadMoreButton = props.setIsLoadMoreButton;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    assignEmployeeShow = _useState4[0],
    setAssignEmployeeShow = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showDeleteModal = _useState6[0],
    setShowDeleteModal = _useState6[1];
  // const [filterEmployee, setSearchFilter] = useState(""); // SEARCH SETTINGS

  var handleClose = function handleClose() {
    return setAssignEmployeeShow(false);
  };
  var handleShow = function handleShow() {
    return setAssignEmployeeShow(true);
  };
  var handleDeleteClose = function handleDeleteClose() {
    return setShowDeleteModal(null);
  };
  var handleDeleteShow = function handleDeleteShow(userId, displayName) {
    var temp = {
      userId: userId,
      displayName: displayName
    };
    setShowDeleteModal(temp);
  };
  var handleLoadMore = function handleLoadMore() {
    if (taskDetailsLoading) return;
    setIsLoadingMore(true);
    TASK_OFFSETS = TASK_OFFSETS + 1;
    taskDetailsFetchMore({
      variables: {
        offset: TASK_OFFSETS * TASK_LIMIT
      },
      updateQuery: function updateQuery(prev, _ref) {
        var _fetchMoreResult$task, _fetchMoreResult$task2, _fetchMoreResult$task3, _fetchMoreResult$task4, _prev$taskDetails, _fetchMoreResult$task5;
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$task = fetchMoreResult.taskDetails) === null || _fetchMoreResult$task === void 0 ? void 0 : (_fetchMoreResult$task2 = _fetchMoreResult$task.employeeDetails) === null || _fetchMoreResult$task2 === void 0 ? void 0 : _fetchMoreResult$task2.length) === 0 && ((_fetchMoreResult$task3 = fetchMoreResult.taskDetails) === null || _fetchMoreResult$task3 === void 0 ? void 0 : (_fetchMoreResult$task4 = _fetchMoreResult$task3.employeeDetails) === null || _fetchMoreResult$task4 === void 0 ? void 0 : _fetchMoreResult$task4.length) < TASK_LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          taskDetails: _objectSpread(_objectSpread({}, prev.taskDetails), {}, {
            employeeDetails: [].concat(_toConsumableArray((_prev$taskDetails = prev.taskDetails) === null || _prev$taskDetails === void 0 ? void 0 : _prev$taskDetails.employeeDetails), _toConsumableArray((_fetchMoreResult$task5 = fetchMoreResult.taskDetails) === null || _fetchMoreResult$task5 === void 0 ? void 0 : _fetchMoreResult$task5.employeeDetails))
          })
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "task-details-employee-list-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-employee-list-card-header"
  }, /*#__PURE__*/React.createElement("span", {
    className: "task-details-employee-list-card-title"
  }, " Task clock-in & clock-out summary")), /*#__PURE__*/React.createElement("div", {
    className: "task-details-employee-list-card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-employee-list-card-data"
  }, /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "task-details-employee-list-card-data-table"
  }, /*#__PURE__*/React.createElement("tbody", null, employeeDetails.map(function (employeeData, key) {
    var _employeeDetails;
    return /*#__PURE__*/React.createElement(React.Fragment, null, key == 0 || !isSameDay(Number((_employeeDetails = employeeDetails[key - 1]) === null || _employeeDetails === void 0 ? void 0 : _employeeDetails.createdAt), Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.createdAt)) ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: "5",
      className: "task-tracker-date-td"
    }, /*#__PURE__*/React.createElement("div", {
      className: "manual-time-date-divider-label-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-tracker-list-date-divider-label"
    }, /*#__PURE__*/React.createElement("span", {
      className: "manual-time-date-divider-label-icon"
    }, /*#__PURE__*/React.createElement(MdDateRange, null)), /*#__PURE__*/React.createElement("span", null, isToday(Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.createdAt)) ? "Today" : isYesterday(Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.createdAt)) ? "Yesterday" : format(Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.createdAt), "dd-LLL-yyyy")))))) : null, key == 0 ? /*#__PURE__*/React.createElement("tr", {
      className: "task-details-employee-list-card-data-header"
    }, /*#__PURE__*/React.createElement("th", null, "Employee Name"), /*#__PURE__*/React.createElement("th", null, "Duration"), /*#__PURE__*/React.createElement("th", null, "Worked Time")) : null, /*#__PURE__*/React.createElement("tr", {
      className: "task-details-employee-list-card-details",
      key: key
    }, /*#__PURE__*/React.createElement("td", {
      className: "task-details-employee-list-card-details-avatar"
    }, " ", employeeData.profileUrl === null || employeeData.profileUrl === "" ? /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-card-avatar"
    }, employeeData.employeeName.charAt(0).toUpperCase()) : /*#__PURE__*/React.createElement("div", {
      className: "task-detail-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "DeskTime",
      src: employeeData.profileUrl,
      className: "task-detail-card-avatar-profile-img"
    })), /*#__PURE__*/React.createElement("p", null, employeeData.employeeName)), /*#__PURE__*/React.createElement("td", null, employeeData.totalTime, " "), /*#__PURE__*/React.createElement("td", null, employeeData.startTime, " -", " ", employeeData.endTime === "Invalid date" ? "Ongoing" : employeeData.endTime, " ")));
  }), employeeDetails.length === 0 ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colspan: "7",
    className: "text-center employee-no-data"
  }, "No data found !!!")) : null)), employeeDetails !== null && employeeDetails !== void 0 && employeeDetails.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the tasks")) : null)));
};
var AssignEmployeeModal = function AssignEmployeeModal(props) {
  var assignEmployeeShow = props.assignEmployeeShow,
    handleClose = props.handleClose,
    teamUser = props.teamUser,
    organisationId = props.organisationId,
    taskId = props.taskId,
    projectId = props.projectId,
    teamId = props.teamId,
    userId = props.userId,
    existUserIds = props.existUserIds;
  var _React$useState9 = React.useState(existUserIds.length ? existUserIds : []),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    userActive = _React$useState10[0],
    setUserActive = _React$useState10[1];
  var userIds = teamUser.map(function (user) {
    return user.userId;
  });

  /**** Assign Employee Submit  *****/

  var _useMutation = useMutation(ASSIGN_EMPLOYEE_TO_TASK_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    assignEmployeeToTask = _useMutation2[0],
    assignEmployeeToTaskLoading = _useMutation2[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var variables, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          variables = {
            taskId: taskId,
            assignedTo: userActive,
            assignedBy: userId,
            projectId: projectId,
            organisationId: organisationId
          };
          _context.prev = 1;
          _context.next = 4;
          return assignEmployeeToTask({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: TASK_DETAILS_QUERY,
              variables: {
                organisationId: organisationId,
                taskId: taskId,
                projectId: projectId,
                teamId: teamId
              }
            }]
          });
        case 4:
          response = _context.sent;
          if (!(!response || !response.data || response.data.assignEmployeeToTask == null)) {
            _context.next = 9;
            break;
          }
          throw new Error("error");
        case 9:
          // setTeamActive
          handleClose();
          toast.success("User updated successfully!");
        case 11:
          _context.next = 16;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](1);
          console.log(_context.t0);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 13]]);
  })), [assignEmployeeToTask, assignEmployeeToTaskLoading, userActive]);

  /**** Assign Employee Submit END  *****/

  return /*#__PURE__*/React.createElement(Modal, {
    show: assignEmployeeShow,
    onHide: handleClose,
    centered: true
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "manage-team-modal-title"
  }, "Assign Employee")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      // projectName: modalType === "editProject" ? projectName : "",
      // team: "",
    }
    // validationSchema={MembersSchema}
    ,
    onSubmit: handleSubmit
  }, function (_ref3) {
    var setFieldValue = _ref3.setFieldValue;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "task-details-assign-employee-modal-content-person-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-details-assign-employee-modal-content-person-name-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-details-assign-employee-modal-content-person-name-header-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-details-assign-employee-modal-content-person-name-header-section-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-details-assign-employee-modal-searchbox-wrapper"
    }, /*#__PURE__*/React.createElement(DebounceInput, {
      className: "task-details-assign-employee-modal-searchbox form-control",
      type: "text",
      placeholder: "Search"
      //  onChange={(e) => setSearchFilter(e.target.value)}
      ,
      minLength: 2,
      debounceTimeout: 800
    }), /*#__PURE__*/React.createElement("div", {
      className: "task-details-assign-employee-icon-wrapper"
    }, /*#__PURE__*/React.createElement(GoSearch, null))), /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "task-details-assign-employee-modal-content-person-name-header-button",
      onClick: function onClick() {
        return setUserActive(userIds);
      }
    }, "Assign All")))), /*#__PURE__*/React.createElement("div", {
      className: "task-details-assign-employee-modal-content-person-name-listing"
    }, teamUser.map(function (user, index) {
      var userFirstName = user.displayName.match(/\b(\w)/g);
      //const displayNameIcon = userFirstName.join("");
      var displayNameIcon = user.displayName.charAt(0).toUpperCase();
      return /*#__PURE__*/React.createElement("div", {
        className: "task-details-assign-employee-modal-content-person-name-listing-card-content",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "task-details-assign-employee-modal-content-person-name-listing-card-content-person"
      }, user.profileUrl === null || user.profileUrl === "" ? /*#__PURE__*/React.createElement("div", {
        className: "task-details-assign-employee-modal-content-person-name-listing-card-content-person-icon"
      }, displayNameIcon) : /*#__PURE__*/React.createElement("div", {
        className: "task-assign-card-avatar-profile"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "DeskTime",
        src: user.profileUrl,
        className: "task-assign-card-avatar-profile-img"
      })), /*#__PURE__*/React.createElement("div", {
        className: "task-details-assign-employee-modal-content-header-team-name",
        onClick: function onClick() {
          return setUserActive(function (prev) {
            return prev.includes(user.userId) ? prev.filter(function (a) {
              return a !== user.userId;
            }) : [].concat(_toConsumableArray(prev), [user.userId]);
          });
        }
      }, user.displayName)), /*#__PURE__*/React.createElement(Forms, null, /*#__PURE__*/React.createElement(Forms.Check, {
        custom: true,
        inline: true,
        label: "",
        type: "checkbox",
        id: user.userId,
        className: "access-control-checkbox",
        checked: userActive.includes(user.userId) //personActive
        ,
        onChange: function onChange() {
          return setUserActive(function (prev) {
            return prev.includes(user.userId) ? prev.filter(function (a) {
              return a !== user.userId;
            }) : [].concat(_toConsumableArray(prev), [user.userId]);
          });
        }
      })));
    })))), /*#__PURE__*/React.createElement(Row, {
      className: "task-details-assign-employee-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-details-assign-employee-modal-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      onClick: function onClick() {
        return handleClose();
      },
      className: "task-details-assign-employee-modal-save-button",
      type: "submit"
    }, "Add Employee")))))));
  })));
};
export default TaskDetails;